import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { ThfTableModule } from '@totvs/thf-ui';

import { ThfPageDynamicSearchModule } from '../thf-page-dynamic-search/thf-page-dynamic-search.module';

import { ThfPageDynamicTableComponent } from './thf-page-dynamic-table.component';

/**
 * @description
 *
 * MÃ³dulo do template do thf-page-dynamic-search.
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,

    ThfTableModule,
    ThfPageDynamicSearchModule
  ],
  declarations: [
    ThfPageDynamicTableComponent
  ],
  exports: [
    ThfPageDynamicTableComponent
  ]
})
export class ThfPageDynamicTableModule { }
